<template>
  <VDialog
    v-model="dialog"
    persistent
    max-width="600px"
  >
    <VBtn
      slot="activator"
      color="primary"
      dark
    >
      {{ $nt('createAdmin') }}
    </VBtn>
    <VCard>
      <VCardTitle>
        <span class="headline">
          {{ $nt('createAdmin') }}
        </span>
      </VCardTitle>
      <VCardText>
        <VForm
          ref="form"
          v-model="isFormValid"
        >
          <VContainer
            grid-list-md
            class="pt-0"
          >
            <VLayout wrap>
              <VFlex row>
                <VTextField
                  v-model="userObj.first_name"
                  :error-messages="errorMessages.first_name"
                  :label="$nt('firstName')"
                  required
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex>
                <VTextField
                  v-model="userObj.last_name"
                  :error-messages="errorMessages.last_name"
                  :label="$nt('lastName')"
                  required
                  :rules="[$rules.isRequired]"
                />
              </VFlex>
              <VFlex xs12>
                <VTextField
                  v-model="userObj.email"
                  :error-messages="errorMessages.email"
                  :label="$nt('email')"
                  required
                  :rules="[$rules.isRequired, $rules.isValidEmail]"
                />
              </VFlex>
            </VLayout>
          </VContainer>
        </VForm>
      </VCardText>
      <VCardActions>
        <VSpacer />
        <VBtn
          flat
          @click="close"
        >
          {{ $nt('close') }}
        </VBtn>
        <VBtn
          color="primary"
          :disabled="isValid || isLoading"
          :loading="isLoading"
          @click="createUser"
        >
          {{ $nt('add') }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import AdminApi from '@/api/AdminApi'

export default {
  name: 'UserCreateAdmin',
  data () {
    return {
      isFormValid: false,
      dialog: false,
      isLoading: false,
      userObj: {
        first_name: '',
        last_name: '',
        email: ''
      },
      errorMessages: {}
    }
  },
  computed: {
    isValid () {
      return !this.isFormValid && Object.getOwnPropertyNames(this.errorMessages).length === 1
    }
  },
  methods: {
    close () {
      this.dialog = false
      this.errorMessages = {}
      this.$refs.form.reset()
    },
    async createUser () {
      if (!this.isValid) {
        this.isLoading = true
        try {
          await this.$notification(AdminApi.createAdminUser(this.userObj))
          this.$emit('onSuccess')
          this.close()
        } catch (e) {
          this.errorMessages = e
        }
        this.isLoading = false
      }
    }
  },
  i18n: {
    messages: {
      de: {
        add: 'Admin anlegen',
        createAdmin: 'Neuer Administrator',
        close: 'Abbrechen',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'Email'
      },
      en: {
        add: 'Create admin',
        createAdmin: 'Create admin',
        close: 'Cancel',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email'
      }
    }
  }
}
</script>
